<template>
    <div>
        <!-- Hero Section Start -->
        <div class="hero-section">
            <div class="hero-wrapper">
                <div class="hero-video">
                    <video autoplay loop muted playsinline>
                        <source
                            src="assets/images/hero-image/main-home.mp4"
                            type="video/mp4"
                        />
                    </video>
                </div>
                <div class="container hero-content" style="max-width: 1400px;">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <div class="hero-left-section">
                                <div class="hero-desc">
                                    <div class="container">
                                        <h1>
                                            Save Time,
                                            <br class="d-lg-block d-none" />
                                            Save Money,
                                            <br class="d-lg-block d-none" />
                                            Build Smarter!
                                        </h1>
                                        <div class="hd-btnset" v-if="!showroomId.showroom">
                                            <a href="/register/contractor" role="button" class="btn btn-primary mb-3">Sign Up as a Pro</a>                                     
                                            <a href="/pro-account" role="button" class="btn btn-secondary mb-3">Learn More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <div class="hero-right-section">
                                <div class="hero-form">
                                    <div class="card">
                                        <div class="card-body">
                                            <h4 class="mb-3 text-capitalize">
                                                Our mission is to reduce the
                                                cost of your renovation
                                            </h4>
                                            <h5 class="mb-3">
                                                We are dedicated to serving
                                                contractors and interior
                                                designers by providing a service
                                                platform that allows homeowners
                                                to source finishing materials
                                                for their next project directly
                                                from manufacturers.
                                            </h5>
                                            <template v-if="(showroomId && showroomId.showroom && enter_showroom) || (showroomId && !showroomId.showroom) || !showroomId">
                                            <h3 class="card-title">
                                                Enter Showroom ID
                                            </h3>
                                            <!-- p.card-text (older class) -->
                                            <p class="font-14">
                                                Ask your Contractor/Designer for
                                                Showroom ID
                                            </p>
                                        </template>
                                            <form>
                                                <div class="row" v-if="(showroomId && showroomId.showroom && enter_showroom) || (showroomId && !showroomId.showroom) || !showroomId">
                                                    <div
                                                        class="col-md-12 col-lg-7"
                                                    >
                                                        <div class="form-group">
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                v-model="
                                                                    search_text
                                                                "
                                                                placeholder="Enter showroom ID"
                                                            />

                                                            <div
                                                                class="font-12"
                                                                v-if="
                                                                    show_search
                                                                "
                                                            >
                                                                <b>
                                                                    {{
                                                                        showroom_name
                                                                    }}</b
                                                                >
                                                            </div>
                                                            <div
                                                                class="font-12 "
                                                                v-if="
                                                                    show_search
                                                                "
                                                            >
                                                                <b>{{
                                                                    vsid
                                                                }}</b>
                                                            </div>
                                                            <!-- <span class="form-text">Having trouble in enter ID?</span> -->
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-md-12 col-lg-5"
                                                    >
                                                        <button
                                                            type="submit"
                                                            class="btn btn-outline-secondary"
                                                            @click.prevent="
                                                                showRoom
                                                            "
                                                            :disabled="
                                                                !show_search
                                                            "
                                                        >
                                                            Next
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="request-text" v-if="showroomId && showroomId.showroom"> 
                                                    
                                                    <router-link
                                                to="/visualize/contractor/all"
                                                type="button"
                                                class="btn btn-outline-secondary  "
                                                ><strong>Continue Shopping</strong>
                                                 </router-link>

                                                 <button 
                                                type="button"
                                                style="max-width: 280px"
                                                class="btn btn-outline-secondary mt-2 font-13 h-auto py-2" @click="enter_showroom=true" v-if="!enter_showroom"
                                                ><span>New Showroom</span>
                                                 </button>
                                                   <!--  signing up, signing in or
                                                    continuing, I agree to
                                                    WeVisu
                                                    <a
                                                        href="#"
                                                        class="text-decoration-underline"
                                                        >Terms of Use</a
                                                    >
                                                    and
                                                    <a
                                                        href="#"
                                                        class="text-decoration-underline"
                                                        >Privacy Policy.</a
                                                    > -->
                                                   </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Hero Section End -->
        <!-- Hero Section End -->

        <!-- Category Section Start -->
        <div class="category-section">
            <div class="container">
                <div class="category-listing">
                    <h2 class="mb-0">Inspired Designs</h2>
                    <ul class="category-list nav nav-tabs" role="tablist">
                        <li class="category-item nav-item" role="presentation">
                            <button
                                class="nav-link active"
                                id="bathroom-cat"
                                data-bs-toggle="pill"
                                data-bs-target="#pro-bathroom"
                                type="button"
                                role="tab"
                                aria-controls="pro-bathroom"
                                aria-selected="false"
                            >
                                Bathroom
                            </button>
                        </li>
                        <li class="category-item nav-item" role="presentation">
                            <button
                                class="nav-link"
                                id="kitchen-cat"
                                data-bs-toggle="pill"
                                data-bs-target="#pro-kitchen"
                                type="button"
                                role="tab"
                                aria-controls="pro-kitchen"
                                aria-selected="false"
                            >
                                Kitchen
                            </button>
                        </li>
                        <li class="category-item nav-item" role="presentation">
                            <button
                                class="nav-link"
                                id="livingroom-cat"
                                data-bs-toggle="pill"
                                data-bs-target="#pro-living-room"
                                type="button"
                                role="tab"
                                aria-controls="pro-living-room"
                                aria-selected="false"
                            >
                                Living Room
                            </button>
                        </li>
                        <li class="category-item nav-item" role="presentation">
                            <button
                                class="nav-link"
                                id="outdoor-cat"
                                data-bs-toggle="pill"
                                data-bs-target="#pro-outdoor"
                                type="button"
                                role="tab"
                                aria-controls="pro-kitchen"
                                aria-selected="false"
                            >
                                Landscaping/Outdoor
                            </button>
                        </li>
                    </ul>
                    <div class="tab-content border border-0">
                        <div
                            class="tab-pane fade show active"
                            id="pro-bathroom"
                            role="tabpanel"
                            aria-labelledby="pro-2-tab"
                            tabindex="0"
                        >
                            <div class="tab-product-list">
                                <div class="category-content">
                                    <div class="row">
                                        <div class="col-md-5 col-lg-4">
                                            <h3>
                                                Discover inspiring picture on
                                                Wevisu
                                            </h3>
                                        </div>
                                        <div class="col-md-7 col-lg-8">
                                            <p class="mb-20">
                                                Sort through a large variety of
                                                tile, find the vanity style
                                                you've been searching for, or
                                                look through our ample selection
                                                of shower systems, faucets, and
                                                accessories. Whatever you need
                                                for your bathroom renovation,
                                                you can find here, all in one
                                                place.
                                            </p>
                                             
                                            <!-- <router-link
                                                to="/projects"
                                                type="button"
                                                class="btn btn-gradient"
                                                ><span>Get your First project</span>
                                                <img
                                                    src="assets/images/color-arrow.svg"
                                                    alt=""
                                            /></router-link> -->
                                        </div>
                                    </div>

                                    <!-- Category Slider Start -->
                                    <div class="category-slider-section">
                                        <div class="category-slider">
                                            <VueSlickCarousel
                                                :images="bathroomsImageSlider"
                                                :slidesToShow="4"
                                                :slidesToScroll="1"
                                                :autoplay="true"
                                                :infinite="true"
                                                :dots="false"
                                                :arrows="true"
                                            >
                                            </VueSlickCarousel>
                                        </div>
                                    </div>
                                    <!-- Category Slider End -->
                                </div>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="pro-kitchen"
                            role="tabpanel"
                            aria-labelledby="kitchen-cat"
                            tabindex="0"
                        >
                            <div class="tab-product-list">
                                <div class="category-content">
                                    <div class="row">
                                        <div class="col-md-5 col-lg-4">
                                            <h3>
                                                Discover inspiring picture on
                                                Wevisu
                                            </h3>
                                        </div>
                                        <div class="col-md-7 col-lg-8">
                                            <p class="mb-20">
                                                Design a functional kitchen with
                                                high-quality materials,
                                                including durable countertops
                                                and flooring. Incorporate top of
                                                the line appliances, faucets and
                                                fixtures that fit your design
                                                style. Whether you are working
                                                towards a modern, contemporary,
                                                or any other design style, you
                                                can find what you need right
                                                here.
                                            </p>
                                             
                                          <!--   <button
                                                type="button"
                                                class="btn btn-gradient"
                                            >
                                                <span
                                                    >Get your First
                                                    project</span
                                                >
                                                <img
                                                    src="assets/images/color-arrow.svg"
                                                    alt=""
                                                />
                                            </button> -->
                                        </div>
                                    </div>

                                    <!-- Category Slider Start -->
                                    <div class="category-slider-section">
                                        <div class="category-slider">
                                            <VueSlickCarousel
                                                :images="kitchenImageSlider"
                                                :slidesToShow="4"
                                                :slidesToScroll="1"
                                                :autoplay="true"
                                                :infinite="true"
                                                :dots="false"
                                                :arrows="true"
                                            >
                                            </VueSlickCarousel>
                                        </div>
                                    </div>
                                    <!-- Category Slider End -->
                                </div>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="pro-living-room"
                            role="tabpanel"
                            aria-labelledby="livingroom-cat"
                            tabindex="0"
                        >
                            <div class="tab-product-list">
                                <div class="category-content">
                                    <div class="row">
                                        <div class="col-md-5 col-lg-4">
                                            <h3>
                                                Discover inspiring picture on
                                                Wevisu
                                            </h3>
                                        </div>
                                        <div class="col-md-7 col-lg-8">
                                            <p class="mb-20">
                                                Choose from a variety of
                                                flooring materials, whether
                                                you're looking for hardwood,
                                                tile, or luxury vinyl, we have
                                                what you need. Create an
                                                ambiance of your choosing with
                                                an inviting fireplace,
                                                surrounded with beautiful
                                                stacked stone, or maybe add
                                                lighting features that tie in
                                                the space. Whatever you envision
                                                for your home, we can help you
                                                create it.
                                            </p>
                                             
                                            <!-- <button
                                                type="button"
                                                class="btn btn-gradient"
                                            >
                                                <span
                                                    >Get your First
                                                    project</span
                                                >
                                                <img
                                                    src="assets/images/color-arrow.svg"
                                                    alt=""
                                                />
                                            </button> -->
                                        </div>
                                    </div>

                                    <!-- Category Slider Start -->
                                    <div class="category-slider-section">
                                        <div class="category-slider">
                                            <VueSlickCarousel
                                                :images="
                                                    livingRoomsImagesSlider
                                                "
                                                :slidesToShow="4"
                                                :slidesToScroll="1"
                                                :autoplay="true"
                                                :infinite="true"
                                                :dots="false"
                                                :arrows="true"
                                            >
                                            </VueSlickCarousel>
                                        </div>
                                    </div>
                                    <!-- Category Slider End -->
                                </div>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="pro-outdoor"
                            role="tabpanel"
                            aria-labelledby="outdoor-cat"
                            tabindex="0"
                        >
                            <div class="tab-product-list">
                                <div class="category-content">
                                    <div class="row">
                                        <div class="col-md-5 col-lg-4">
                                            <h3>
                                                Discover inspiring picture on
                                                Wevisu
                                            </h3>
                                        </div>
                                        <div class="col-md-7 col-lg-8">
                                            <p class="mb-20">
                                                There are many ways to transform
                                                your outdoor space. Whether you
                                                are looking to create a new deck
                                                for entertaining, or design the
                                                pool or your dreams, WeVisu has
                                                the materials to make that dream
                                                a reality. Feel free to shop
                                                turf, pavers, and many other
                                                outdoor materials!
                                            </p>
                                            
                                           <!--  <button
                                                type="button"
                                                class="btn btn-gradient"
                                            >
                                                <span
                                                    >Get your First
                                                    project</span
                                                >
                                                <img
                                                    src="assets/images/color-arrow.svg"
                                                    alt=""
                                                />
                                            </button> -->
                                        </div>
                                    </div>

                                    <!-- Category Slider Start -->
                                    <div class="category-slider-section">
                                        <div class="category-slider">
                                            <VueSlickCarousel
                                                :images="outDoorImagesSlider"
                                                :slidesToShow="4"
                                                :slidesToScroll="1"
                                                :autoplay="true"
                                                :infinite="true"
                                                :dots="false"
                                                :arrows="true"
                                            >
                                            </VueSlickCarousel>
                                        </div>
                                    </div>
                                    <!-- Category Slider End -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Category Section End -->

        <!-- Partners Slider Start -->
        <div class="partners-section">
            <div class="container">
                <div class="secondary-title">
                    <h3 class="title-text">Our Brand Partners</h3>
                    <router-link
                        to="/our-brands"
                        type="button"
                        class="btn btn-gradient"
                        ><span>See All</span>
                        <img src="assets/images/color-arrow.svg" alt=""
                    /></router-link>
                </div>

                <div class="partners-slider-section">
                    <!-- First Slider -->
                    <div class="partners-slider-first">
                        <VueSlickCarouselFinal
                            :slidesToShow="6"
                            :slidesToScroll="1"
                            :autoplay="true"
                            :infinite="true"
                            :dots="false"
                            :arrows="false"
                            :speed="8000"
                            :autoplaySpeed="0"
                            :centerMode="true"
                            :cssEase="'linear'"
                            :responsive="[
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 4
                                    }
                                },
                                {
                                    breakpoint: 767,
                                    settings: {
                                        slidesToShow: 2
                                    }
                                },
                                {
                                    breakpoint: 480,
                                    settings: {
                                        slidesToShow: 1
                                    }
                                }
                            ]"
                        >
                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/as.svg"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/avanity.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/bedrosians.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/brizo.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/cali.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/delta.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/ember-tile.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>
                        </VueSlickCarouselFinal>
                    </div>

                    <!-- Second Slider -->
                    <div class="partners-slider-second" dir="rtl">
                        <VueSlickCarouselFinal
                            :rtl="true"
                            :slidesToShow="6"
                            :slidesToScroll="1"
                            :autoplay="true"
                            :infinite="true"
                            :dots="false"
                            :arrows="false"
                            :speed="8000"
                            :autoplaySpeed="0"
                            :centerMode="true"
                            :cssEase="'linear'"
                            :responsive="[
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 4
                                    }
                                },
                                {
                                    breakpoint: 767,
                                    settings: {
                                        slidesToShow: 2
                                    }
                                },
                                {
                                    breakpoint: 480,
                                    settings: {
                                        slidesToShow: 1
                                    }
                                }
                            ]"
                        >
                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/hansgrohe.jpg"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/isenberg.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/lg.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/maxim.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/mir.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/moen.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/mohawk.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>
                        </VueSlickCarouselFinal>
                    </div>

                    <!-- Third Slider -->
                    <div class="partners-slider-third">
                        <VueSlickCarouselFinal
                            :slidesToShow="6"
                            :slidesToScroll="1"
                            :autoplay="true"
                            :infinite="true"
                            :dots="false"
                            :arrows="false"
                            :speed="8000"
                            :autoplaySpeed="0"
                            :centerMode="true"
                            :cssEase="'linear'"
                            :responsive="[
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 4
                                    }
                                },
                                {
                                    breakpoint: 767,
                                    settings: {
                                        slidesToShow: 2
                                    }
                                },
                                {
                                    breakpoint: 480,
                                    settings: {
                                        slidesToShow: 1
                                    }
                                }
                            ]"
                        >
                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/msi.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/panasonic.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/samsung.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/tilebar.svg"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/toto.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/we.png"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>

                            <div>
                                <div class="category-item">
                                    <img
                                        src="assets/images/vendor-logo/top/as.svg"
                                        alt="brand logo"
                                    />
                                </div>
                            </div>
                        </VueSlickCarouselFinal>
                    </div>
                </div>
            </div>
        </div>
        <!-- Partners Slider End -->

        <!-- Browse Section Start -->
        <div class="browse-section">
            <div class="container">
                <div class="secondary-title border-bottom-1">
                    <h3 class="title-text">Shop by category</h3>
                    
                    <router-link
                        to="/visualize/contractor/all"
                        type="button"
                        class="btn btn-gradient"
                        v-if="showroomId && showroomId.showroom"
                        ><span>See All</span>
                        <img src="assets/images/color-arrow.svg" alt=""/>
                        </router-link>

                    <a v-else
                        href="#"
                        type="button"
                        class="btn btn-gradient"
                        data-toggle="modal"
                        data-target="#exampleModal"
                        ><span>See All</span>
                        <img src="assets/images/color-arrow.svg" alt=""
                    /></a>
                </div>

                <div class="shop-slider shop-slider-first">
                    <VueSlickCarouselFinal
                        :slidesToShow="4"
                        :slidesToScroll="1"
                        :autoplay="true"
                        :infinite="true"
                        :dots="false"
                        :arrows="true"
                        :responsive="[
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 2
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]"
                    >
                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/appliances.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    ref="categoryName"
                                    value="appliances"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Appliances')"
                                >
                                    Appliances
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/artificial-turf.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    @click="setCategoryName(' Artificial Turf')"
                                >
                                    Artificial Turf
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/backsplash-tiles.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Backsplash Tiles')"
                                >
                                    Backsplash Tiles
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/bathroom-faucets.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Bathroom Faucets')"

                                >
                                    Bathroom Faucets
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/bathroom-vanitys.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Bathroom Vanitys')"
                                >
                                    Bathroom Vanitys
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/bathtubs.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Bath Tubs')"
                                >
                                    Bath Tubs
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/cabinet-hardware.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Cabinet Hardware')"
                                >
                                    Cabinet Hardware
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/countertop.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Countertop')"
                                >
                                    Countertop
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/fans.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Fans')"
                                >
                                    Fans
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/hardscaping.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Hardscaping')"
                                >
                                    Hardscaping
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/hardwood-flooring.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Hardwood Flooring')"
                                >
                                    Hardwood Flooring
                                </button>
                            </div>
                        </div>

                        <template #prevArrow="arrowOption">
                            <div class="slick-prev slick-arrow">
                                <img src="assets/images/prev-round-arrow.svg" />
                            </div>
                        </template>
                        <template #nextArrow="arrowOption">
                            <div class="slick-next slick-arrow">
                                <img src="assets/images/next-round-arrow.svg" />
                            </div>
                        </template>
                    </VueSlickCarouselFinal>
                </div>

                <div class="shop-slider shop-slider-second">
                    <VueSlickCarouselFinal
                        :slidesToShow="4"
                        :slidesToScroll="1"
                        :autoplay="true"
                        :infinite="true"
                        :dots="false"
                        :arrows="true"
                        :centerMode="false"
                        :responsive="[
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 2
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]"
                    >
                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/kitchen-faucets.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    ref="categoryName"
                                    value="appliances"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Kitchen Faucets')"
                                >
                                    Kitchen Faucets
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/kitchen-sinks.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    ref="categoryName"
                                    value="appliances"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Kitchen Sinks')"
                                >
                                    Kitchen Sinks
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/laminate-flooring.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    ref="categoryName"
                                    value="appliances"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Laminate Flooring')"
                                >
                                    Laminate Flooring
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/lights.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    ref="categoryName"
                                    value="appliances"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Lights')"
                                >
                                    Lights
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/luxury-vinyl-flooring.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    ref="categoryName"
                                    value="appliances"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('luxury-flooring')"
                                >
                                    luxury-flooring
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/pool-copings.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    ref="categoryName"
                                    value="appliances"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Pool Copings')"
                                >
                                    Pool Copings
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/showers.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    ref="categoryName"
                                    value="appliances"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Showers')"
                                >
                                    Showers
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/stacked-stone.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    ref="categoryName"
                                    value="appliances"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Stacked Stone')"
                                >
                                    Stacked Stone
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/tile-flooring.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    ref="categoryName"
                                    value="appliances"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Tile Flooring')"
                                >
                                    Tile Flooring
                                </button>
                            </div>
                        </div>

                        <div>
                            <div class="browse-item">
                                <img
                                    class="item-bg"
                                    src="assets/images/shop/toilets.jpg"
                                    alt=""
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    data-toggle="modal"
                                    ref="categoryName"
                                    value="appliances"
                                    data-target="#exampleModal"
                                    @click="setCategoryName('Toilets')"
                                >
                                    Toilets
                                </button>
                            </div>
                        </div>
                        <template #prevArrow="arrowOption">
                            <div class="slick-prev slick-arrow">
                                <img src="assets/images/prev-round-arrow.svg" />
                            </div>
                        </template>
                        <template #nextArrow="arrowOption">
                            <div class="slick-next slick-arrow">
                                <img src="assets/images/next-round-arrow.svg" />
                            </div>
                        </template>
                    </VueSlickCarouselFinal>
                </div>
            </div>
        </div>
        <!-- Browse Section End -->

        <!-- Work Section Start -->
        <div class="work-section">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 col-lg-5">
                        <div class="work-left">
                            <!-- <div class="row gx-3">
                                <div class="col-5">
                                    <div class="work-img mb-3 justify-content-end">
                                        <img src="assets/images/work-img-01.png" alt="">
                                    </div>
                                    <div class="work-img justify-content-end">
                                        <img src="assets/images/work-img-02.png" alt="">
                                    </div>
                                </div>
                                <div class="col-7 align-self-end">
                                    <div class="work-img">
                                        <img src="assets/images/work-img-03.png" alt="">
                                    </div>
                                </div>
                            </div> -->
                            <div class="work-img">
                                <img
                                    src="assets/images/become-img.png"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-7">
                        <div class="work-right mx-auto">
                            <h2 class="mb-3 work-title">
                                Become a pro at
                                <img
                                    src="assets/images/wevisu-plus-white.svg"
                                    alt=""
                                />
                            </h2>
                            <p class="mb-4">
                                Considering building a virtual showroom? Opt for
                                Wevisu+ and unlock savings of up to 60% on your
                                materials. Our platform empowers you to craft an
                                immersive client experience, eradicating the
                                need for physical samples and expensive travel.
                                The inclusion of real-time live experts on our
                                App, guarantees a seamless and tailored design
                                process. Get in touch with us to explore
                                further, and spearhead a groundbreaking
                                transformation in your virtual showroom.
                            </p>
                            <!-- <a
                                class="btn btn-primary"
                                href="https://calendly.com/wevisu/wevisu"
                                role="button"
                                >Join Pro</a
                            > -->
                            
                            <div class="hd-btnset" v-if="!showroomId.showroom">
                                <a href="/register/contractor" role="button" class="btn btn-primary mb-3">Sign Up as a Pro</a>                                     
                                <a href="/pro-account" role="button" class="btn btn-secondary mb-3">Learn More</a>
                            </div>
                            <ul class="app-store list-unstyled mt-4 d-flex">
                                <li class="me-3"><a target="_blank" href="https://play.google.com/store/apps/details?id=com.wevisu&pcampaignid=web_share"><img src="assets/images/google-play.png" alt=""></a></li> 
                                <li><a target="_blank" href="https://apps.apple.com/in/app/wevisu-pro/id6456797507"><img src="assets/images/app-store.png" alt=""></a></li> 
                                
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Work Section End -->

        <!-- Why Section Start -->
        <div class="why-section">
            <div class="container">
                <div class="section-title">
                    <h3 class="title-text">Why join WeVisu community</h3>
                </div>
                <div class="row">
                    <div class="col-md-5 col-lg-4">
                        <h3>
                            In the ever-evolving renovation industry, our
                            virtual showroom platform serves as a game-changer.
                        </h3>
                    </div>
                    <div class="col-md-7 col-lg-8">
                        <p>
                            Empowering contractors and interior designers to
                            open their own e-commerce and redefine how they
                            engage with clients. By gaining direct access to
                            manufacturer products, offering substantial savings,
                            and eliminating physical showroom visits,
                            professionals can transform the renovation
                            experience, delivering superior services to their
                            clients. With our platform, the future of the
                            renovation industry is brighter than ever before.
                        </p>
                    </div>
                </div>
                <div class="why-circle-section">
                    <div class="why-main-circle">
                        <img
                            class="bg-img"
                            src="assets/images/why-bg.svg"
                            alt=""
                        />
                        <div class="why-logo">
                            <img src="assets/images/new-logo.svg" alt="" />
                        </div>
                    </div>

                    <div class="why-item item-first left-item">
                        <div class="item-img order-1 order-md-0">
                            <img src="assets/images/why-item-01.svg" alt="" />
                        </div>
                        <div class="item-detail">
                            <h6 class="item-title">Visualizer</h6>
                            <p class="item-text">
                                Visualize your remodel using materials from
                                different brands together in one space.
                            </p>
                        </div>
                    </div>

                    <div class="why-item item-second left-item">
                        <div class="item-img">
                            <img src="assets/images/why-item-02.svg" alt="" />
                        </div>
                        <div class="item-detail">
                            <h6 class="item-title">Support</h6>
                            <p class="item-text">
                                We are here to assist for any question you may
                                have in regard to your project materials.
                            </p>
                        </div>
                    </div>

                    <div class="why-item item-third left-item">
                        <div class="item-img order-1 order-md-0">
                            <img src="assets/images/why-item-03.svg" alt="" />
                        </div>
                        <div class="item-detail">
                            <h6 class="item-title">Delivery and Service</h6>
                            <p class="item-text">
                                Providing nationwide delivery for FREE
                            </p>
                        </div>
                    </div>

                    <div class="why-item item-fourth right-item">
                        <div class="item-detail order-1 order-md-0">
                            <h6 class="item-title">Live chat</h6>
                            <p class="item-text">
                                Connect with a dedicated project assistant using
                                the WeVisu+ App
                            </p>
                        </div>
                        <div class="item-img">
                            <img src="assets/images/why-item-04.svg" alt="" />
                        </div>
                    </div>

                    <div class="why-item item-fifth right-item">
                        <div class="item-detail">
                            <h6 class="item-title">
                                Communicate with Contractor
                            </h6>
                            <p class="item-text">
                                Do your project with WeVisu+ app to stay committed
                                to your clients.
                            </p>
                        </div>
                        <div class="item-img">
                            <img src="assets/images/why-item-05.svg" alt="" />
                        </div>
                    </div>

                    <div class="why-item item-sixth right-item">
                        <div class="item-detail order-1 order-md-0">
                            <h6 class="item-title">Budget Friendly</h6>
                            <p class="item-text">
                                Save you and your customers up to 60% off with
                                direct manufacturer pricing
                            </p>
                        </div>
                        <div class="item-img">
                            <img src="assets/images/why-item-06.svg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Why Section End -->

        <!-- Testimonial Section Start -->
        <div class="testimonial-section">
            <div class="container">
                <div class="section-title border-bottom-1">
                    <h3 class="title-text">Client Success Story</h3>
                </div>

                <div class="testimonial-slider-block">
                    <div class="row">
                        <div class="col-md-4 col-lg-4">
                            <div class="testimonial-slider-first">
                                <VueSlickCarouselFinal
                                    :slidesToScroll="1"
                                    :autoplay="true"
                                    :infinite="true"
                                    :centerMode="true"
                                    :dots="false"
                                    :arrows="false"
                                    :vertical="true"
                                    :verticalSwiping="true"
                                    :speed="6000"
                                    :autoplaySpeed="0"
                                    :cssEase="'linear'"
                                    :responsive="[
                                        {
                                            breakpoint: 767,
                                            settings: {
                                                slidesToShow: 1,
                                                slidesToScroll: 1,
                                                vertical: false,
                                                verticalSwiping: false,
                                                centerMode: false
                                            }
                                        }
                                    ]"
                                >
                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <!-- <div class="user-img">
                                                        <img src="assets/images/testimonial/user-img-01.png" alt="">
                                                    </div> -->
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <!--                                                            <li><i class="fa fa-star" aria-hidden="true"></i></li>-->
                                                            <!--                                                            <li><i class="fa fa-star" aria-hidden="true"></i></li>-->
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div class="country-flag">
                                                    <img
                                                        src="assets/images/testimonial/spain-flag.png"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    Exceptional shopping
                                                    experience! wevisu offered a
                                                    wide selection of
                                                    top-quality materials. Their
                                                    knowledgeable staff provided
                                                    valuable advice, making the
                                                    process smooth and
                                                    enjoyable.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                                <!-- <p class="country-name">Spain</p> -->
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <!-- <div class="user-img">
                                                        <img src="assets/images/testimonial/user-img-04.png" alt="">
                                                    </div> -->
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div class="country-flag">
                                                    <img
                                                        src="assets/images/testimonial/indonesia-flag.png"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    I think every contractor can
                                                    agree, coordinating
                                                    materials is more work than
                                                    it seems. Using the
                                                    platform, not only is my
                                                    time and attention needed
                                                    significantly less, my
                                                    customers' experience is
                                                    like no other.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                                <!-- <p class="country-name">Indonesia</p> -->
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <!-- <div class="user-img">
                                                        <img src="assets/images/testimonial/user-img-07.png" alt="">
                                                    </div> -->
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div class="country-flag">
                                                    <img
                                                        src="assets/images/testimonial/malawi-flag.png"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    I remodel units for
                                                    apartments and condos, and
                                                    the ability to get all my
                                                    materials in one order,
                                                    having to only keep track of
                                                    one order, is beyond genius.
                                                    You can't beat the pricing
                                                    and convenience.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                                <!-- <p class="country-name">Malawi</p> -->
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <!-- <div class="user-img">
                                                        <img src="assets/images/testimonial/user-img-01.png" alt="">
                                                    </div> -->
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div class="country-flag">
                                                    <img
                                                        src="assets/images/testimonial/spain-flag.png"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    I have never had the 'eye'
                                                    for putting materials
                                                    together, I just know how to
                                                    put them in. So when
                                                    customers come to me for
                                                    help, I usually suggest what
                                                    I have used in projects
                                                    before.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                                <!-- <p class="country-name">Spain</p> -->
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div class="country-flag">
                                                    <img
                                                        src="assets/images/testimonial/spain-flag.png"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    This platform turned out to
                                                    be well worth my while. The
                                                    team always treats my
                                                    customers with the highest
                                                    quality of service. I always
                                                    get a fast response, and it
                                                    saves me so much time.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div class="country-flag">
                                                    <img
                                                        src="assets/images/testimonial/spain-flag.png"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    Placing orders for materials
                                                    was my least favorite part
                                                    of my process before. I
                                                    still have to put work in
                                                    with custom built materials
                                                    but, outside of that, this
                                                    platform takes care of that
                                                    obstacle for me.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Designer
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div class="country-flag">
                                                    <img
                                                        src="assets/images/testimonial/spain-flag.png"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    My wife had way too much fun
                                                    with the visualizer tool. I
                                                    was just happy we didn't
                                                    have to drive around all day
                                                    on my only day off every
                                                    week. If we would have had
                                                    to drive to showrooms for
                                                    her to look at stuff, I
                                                    don't think we would have
                                                    ever finished.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Homeowner
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div class="country-flag">
                                                    <img
                                                        src="assets/images/testimonial/spain-flag.png"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    Wide variety of choices, and
                                                    I loved the visualizer tool.
                                                    I don't think I could have
                                                    put together such an elegant
                                                    kitchen without the help of
                                                    this platform.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Homeowner
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div class="country-flag">
                                                    <img
                                                        src="assets/images/testimonial/spain-flag.png"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    I introduced this platform
                                                    to my contracting company.
                                                    It took half of my work
                                                    load, if not more!
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Project Manager
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div class="country-flag">
                                                    <img
                                                        src="assets/images/testimonial/spain-flag.png"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    They have the best prices
                                                    and the customer service was
                                                    outstanding. I will be using
                                                    them for the next project in
                                                    my house.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Homeowner
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </VueSlickCarouselFinal>
                            </div>
                        </div>
                        <div class="col-md-4 col-lg-4">
                            <div class="testimonial-slider-second">
                                <VueSlickCarouselFinal
                                    :slidesToScroll="1"
                                    :autoplay="true"
                                    :infinite="true"
                                    :centerMode="true"
                                    :dots="false"
                                    :arrows="false"
                                    :vertical="true"
                                    :verticalSwiping="true"
                                    :speed="6000"
                                    :autoplaySpeed="0"
                                    :cssEase="'linear'"
                                    :responsive="[
                                        {
                                            breakpoint: 767,
                                            settings: {
                                                slidesToShow: 1,
                                                slidesToScroll: 1,
                                                vertical: false,
                                                verticalSwiping: false,
                                                centerMode: false
                                            }
                                        }
                                    ]"
                                >
                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    Their customer service is
                                                    outstanding, they
                                                    coordinated everything from
                                                    conceptualization using
                                                    their 3-D design tool to
                                                    delivery.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Designer
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    Their marketplace is amazing
                                                    and easy to use with so many
                                                    options. Their staff is
                                                    knowledgeable and friendly.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    I can't recommend them
                                                    enough, the marketplace was
                                                    a breeze to use and any
                                                    questions were answered
                                                    quickly by staff that know
                                                    what they are doing. I'm
                                                    very satisfied with the
                                                    service and quality.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    The wevisu website is so
                                                    easy to navigate and their
                                                    staff answered all my
                                                    questions and made the whole
                                                    experience amazing for
                                                    myself and my customer.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Designer
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    The wevisu marketplace is
                                                    stellar and there are so
                                                    many quality options
                                                    available. Their team made
                                                    the whole experience great.
                                                    They answered all my
                                                    questions and were so
                                                    helpful and knowledgeable.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Homeowner
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    Their marketplace and design
                                                    tool was fun to use and so
                                                    many options. Their staff is
                                                    amazing and so quick to
                                                    respond. The whole
                                                    experience was amazing and
                                                    they have such fast
                                                    delivery.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    Fantastic site and made the
                                                    whole job easier. They have
                                                    great customer service and
                                                    they know what they are
                                                    doing. Everything was
                                                    delivered in under 1 weeks
                                                    and they have great pricing.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    I used the marketplace and
                                                    design tool with my customer
                                                    and it is amazing. Fabulous
                                                    selection and great quality.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Designer
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    Amazing selection and
                                                    cheapest prices around. They
                                                    have free shipping in under
                                                    3 weeks and the customer
                                                    service rep that helped me
                                                    was phenomenal.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    Wevisu is an amazing site
                                                    with tons of options and
                                                    great customer service.
                                                    Great service, great
                                                    delivery and great prices.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Designer
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    I had the best experience
                                                    with this website. Very easy
                                                    to use and so many quality
                                                    products. Their sales rep
                                                    did a great job with the
                                                    whole process from start to
                                                    finish.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </VueSlickCarouselFinal>
                            </div>
                        </div>
                        <div class="col-md-4 col-lg-4">
                            <div class="testimonial-slider-third">
                                <VueSlickCarouselFinal
                                    :slidesToScroll="1"
                                    :autoplay="true"
                                    :infinite="true"
                                    :centerMode="true"
                                    :dots="false"
                                    :arrows="false"
                                    :vertical="true"
                                    :verticalSwiping="true"
                                    :speed="6000"
                                    :autoplaySpeed="0"
                                    :cssEase="'linear'"
                                    :responsive="[
                                        {
                                            breakpoint: 767,
                                            settings: {
                                                slidesToShow: 1,
                                                slidesToScroll: 1,
                                                vertical: false,
                                                verticalSwiping: false,
                                                centerMode: false
                                            }
                                        }
                                    ]"
                                >
                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    Their website is phenomenal
                                                    and their team is very
                                                    helpful and informative.
                                                    There are so many quality
                                                    products to choose from. My
                                                    customer was delighted with
                                                    the 3-D design tool and the
                                                    whole process was smooth.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Designer
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    Their website was easy to
                                                    use and their customer
                                                    service was outstanding.
                                                    Superior products and free
                                                    delivery in just a few
                                                    weeks. I am using this site
                                                    on all my projects.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    The wevisu website made
                                                    everything easier. They have
                                                    great quality with the best
                                                    prices I've found. My
                                                    customer was very satisfied
                                                    and loved the marketplace
                                                    with so many choices and
                                                    beautiful designs.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Designer
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    Exceptional service and
                                                    wevisu marketplace had
                                                    everything I needed with a
                                                    much better price. I
                                                    recommend them to anyone who
                                                    needs stellar customer
                                                    service and excellent
                                                    quality.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Homeowner
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    First-rate website, wevisu
                                                    marketplace has great
                                                    products and services. I
                                                    have used them for all of my
                                                    jobs for the last year and
                                                    they have never let me down.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    They have excellent products
                                                    at a great price. Wevisu is
                                                    a great website and their
                                                    team handles all the
                                                    logistics for you.
                                                    Everything showed up as
                                                    expected.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    Wevisu carries national
                                                    brands with better pricing
                                                    than I've found anywhere
                                                    else. Their website is easy
                                                    to use.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Designer
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    This was my first remodel
                                                    and the wevisu website was
                                                    so easy to use and the staff
                                                    so helpful and friendly. I
                                                    had a great experience from
                                                    start to finish.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Homeowner
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    The wevisu website is easy
                                                    to use and their team worked
                                                    closely with me to get
                                                    everything I needed. Their
                                                    team is professional and
                                                    knowledgeable. Their
                                                    products are of great
                                                    quality and value.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    We used the wevisu website
                                                    to design our remodel. They
                                                    have so many great products
                                                    and their service team
                                                    helped us with everything
                                                    from ordering to delivery
                                                    right to our driveway.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Homeowner
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    This is my second time using
                                                    wevisu and they did not
                                                    disappoint, from start to
                                                    finish. The team was very
                                                    professional and the prices
                                                    were very reasonable.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Contractor
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="testimonial-item">
                                            <div class="testimonial-header">
                                                <div class="user-detail">
                                                    <div class="user-star">
                                                        <ul>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                            <li class="active">
                                                                <i
                                                                    class="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="user-quote">
                                                        <i
                                                            class="fa fa-quote-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="testimonial-body">
                                                <p>
                                                    This is my second time using
                                                    wevisu and they have the
                                                    best website and design
                                                    tool. They have the best
                                                    customer service rep helping
                                                    me. She answers all my
                                                    questions and helps me get
                                                    what I am looking for with
                                                    great prices.
                                                </p>
                                            </div>
                                            <div class="user-name">
                                                <h6 class="user-title">
                                                    Homeowner
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </VueSlickCarouselFinal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Testimonial Section End -->
        <div class="customer-section">
            <div class="container">
                <div class="section-title border-bottom-1">
                    <h2 class="title-text">Make your customer happier</h2>
                </div>
                <div
                    class="row row-cols-1 row-cols-md-3 row-cols-lg-3 row-cols-xl-3"
                >
                    <div class="col">
                        <div class="customer-item">
                            <div class="customer-item-img">
                                <img
                                    src="assets/images/customer-img-01.jpg"
                                    alt="customer img"
                                />
                            </div>
                            <div class="customer-item-detail">
                                <h6>Kitchen products</h6>
                                <p>
                                    <img src="assets/images/price.svg" alt="" />
                                    Avg. Save <b>55%</b>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="customer-item">
                            <div class="customer-item-img">
                                <img
                                    src="assets/images/customer-img-02.jpg"
                                    alt="customer img"
                                />
                            </div>
                            <div class="customer-item-detail">
                                <h6>Bathroom products</h6>
                                <p>
                                    <img src="assets/images/price.svg" alt="" />
                                    Avg. Save <b>30%</b>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="customer-item">
                            <div class="customer-item-img">
                                <img
                                    src="assets/images/customer-img-03.jpg"
                                    alt="customer img"
                                />
                            </div>
                            <div class="customer-item-detail">
                                <h6>Outdoor products</h6>
                                <p>
                                    <img src="assets/images/price.svg" alt="" />
                                    Avg. Save <b>40%</b>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">-->
        <!--            Launch demo modal-->
        <!--        </button>-->

        <!-- Modal -->
        <div
            class="modal fade"
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 940px;">
                <div class="modal-content">

                    <div class="cs-modal">
                        <button
                        type="button"
                        class="btn btn-close"
                        data-dismiss="modal"
                        aria-label="Close"
                        ></button>
                        <div class="modal-lft">

                        </div>
                        <div class="modal-rgt">
                            <!-- <h5>{{categoryName}}</h5>
                            <input
                            type="text"
                            class="form-control"
                            v-model="search_text"
                            placeholder="Enter showroom ID"
                        />

                        <div class="font-12" v-if="show_search">
                            <b> {{ showroom_name }}</b>
                        </div>
                        <div class="font-12 " v-if="show_search">
                            <b>{{ vsid }}</b> -->
                            <div class="card">
                                        <div class="card-body">
                                            <h4 class="mb-3 text-capitalize">
                                                Our mission is to reduce the
                                                cost of your renovation
                                            </h4>
                                            <h5 class="mb-3">
                                                To access your professional showroom page and explore a variety of renovation materials, and remarkable saving ,simply ask your Pro for their Showroom ID. With the ID, you can unlock a wide range of products tailored to your needs, including bathroom essentials, kitchen fixtures, and outdoor options. Get ready to embark on an exciting shopping adventure! So start save Time save money and start shopping smart
                                            </h5>
                                            <template v-if="(showroomId && showroomId.showroom && enter_showroom) || (showroomId && !showroomId.showroom) || !showroomId">
                                            <h3 class="card-title">
                                                Enter Showroom ID
                                            </h3>
                                            <p class="card-text">
                                                Ask your Contractor/Designer for
                                                Showroom ID 
                                            </p>
                                        </template> 
                                            <form>
                                                <div class="row" v-if="(showroomId && showroomId.showroom && enter_showroom) || (showroomId && !showroomId.showroom) || !showroomId">
                                                    <div
                                                        class="col-md-12 col-lg-7"
                                                    >
                                                        <div class="form-group">
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                v-model="
                                                                    search_text
                                                                "
                                                                placeholder="Enter showroom ID"
                                                            />

                                                            <div
                                                                class="font-12"
                                                                v-if="
                                                                    show_search
                                                                "
                                                            >
                                                                <b>
                                                                    {{
                                                                        showroom_name
                                                                    }}</b
                                                                >
                                                            </div>
                                                            <div
                                                                class="font-12 "
                                                                v-if="
                                                                    show_search
                                                                "
                                                            >
                                                                <b>{{
                                                                    vsid
                                                                }}</b>
                                                            </div>
                                                            <!-- <span class="form-text">Having trouble in enter ID?</span> -->
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-md-12 col-lg-5"
                                                    >
                                                        <button
                                                            type="submit"
                                                            class="btn btn-outline-secondary"
                                                            @click.prevent="
                                                                showRoom
                                                            "
                                                            :disabled="
                                                                !show_search
                                                            "
                                                        >
                                                            Next
                                                        </button>
                                                    </div>
                                                </div>

                                              

                                                <p class="request-text" v-if="showroomId && showroomId.showroom">
                                                    <router-link
                                                to="/visualize/contractor/all"
                                                type="button"
                                                class="btn  "
                                                ><strong>Back to shopping</strong>
                                                 </router-link>

                                                    <!-- signing up, signing in or
                                                    continuing, I agree to
                                                    WeVisu
                                                    <a
                                                        href="#"
                                                        class="text-decoration-underline"
                                                        >Terms of Use</a
                                                    >
                                                    and
                                                    <a
                                                        href="#"
                                                        class="text-decoration-underline"
                                                        >Privacy Policy.</a
                                                    > -->
                                                </p>
                                            </form>
                                        </div>
                                    </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import VueSlickCarousel from "../components/VueSlickCarousel.vue";
import VueSlickCarouselFinal from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import axios from "axios";

const bathroomsImageSlider = [
    "assets/images/bathroom/bathroom-img-01.jpg",
    "assets/images/bathroom/bathroom-img-02.jpg",
    "assets/images/bathroom/bathroom-img-03.jpg",
    "assets/images/bathroom/bathroom-img-04.jpg",
    "assets/images/bathroom/bathroom-img-05.jpg",
    "assets/images/bathroom/bathroom-img-06.jpg",
    "assets/images/bathroom/bathroom-img-07.jpg"
];
const kitchenImageSlider = [
    "assets/images/kitchen/kitchen-img-01.jpg",
    "assets/images/kitchen/kitchen-img-02.jpg",
    "assets/images/kitchen/kitchen-img-03.jpg",
    "assets/images/kitchen/kitchen-img-04.jpg",
    "assets/images/kitchen/kitchen-img-05.jpg",
    "assets/images/kitchen/kitchen-img-06.jpg",
    "assets/images/kitchen/kitchen-img-07.jpg"
];

const livingRoomsImagesSlider = [
    "assets/images/livingroom/livingroom-img-01.jpg",
    "assets/images/livingroom/livingroom-img-02.jpg",
    "assets/images/livingroom/livingroom-img-03.jpg",
    "assets/images/livingroom/livingroom-img-04.jpg",
    "assets/images/livingroom/livingroom-img-05.jpg",
    "assets/images/livingroom/livingroom-img-06.jpg",
    "assets/images/livingroom/livingroom-img-07.jpg"
];

const outDoorImagesSlider = [
    "assets/images/outdoor/outdoor-img-01.jpg",
    "assets/images/outdoor/outdoor-img-02.jpg",
    "assets/images/outdoor/outdoor-img-03.jpg",
    "assets/images/outdoor/outdoor-img-04.jpg",
    "assets/images/outdoor/outdoor-img-05.jpg",
    "assets/images/outdoor/outdoor-img-06.jpg",
    "assets/images/outdoor/outdoor-img-07.jpg"
];
export default {
    components: {
        VueSlickCarousel,
        VueSlickCarouselFinal
    },
    computed:{ 
        ...mapGetters({ 
            showroomId:'Common/MyItem', 
        })
     },

    data() {
        return {
            enter_showroom: false,
            bathroomsImageSlider: bathroomsImageSlider,
            kitchenImageSlider: kitchenImageSlider,
            livingRoomsImagesSlider: livingRoomsImagesSlider,
            outDoorImagesSlider: outDoorImagesSlider,
            showroom_id: "",
            // blog: [],
            showroom_name: "",
            vsid: "",
            search_text: "",
            show_search: false,
            focusShowroom: false,
            categoryName:''
        };
    },
    watch: {
        async search_text(n) {
            if (n.length == 8) {
                await this.filter_contractor();
            }
        }
    },

    methods: {
        ...mapActions("Common", [
            "updateNewLayout",
            "updateMyItem",
            "AddItemShowroom",
            "updateCategory",
            "updateBreadcrumb"
        ]),
        ...mapActions("cart", ["projectCreatRequest"]),

        setCategoryName(name){
            if(this.showroomId && this.showroomId.showroom){
                this.$router
                            .push("/visualize/contractor/all")
                            .catch(() => {});
            }
          this.categoryName=name;
        },

        goToShowRoom() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
            this.focusShowroom = true;
        },

        showRoom() {
            let loaderd = "";
            loaderd = this.$loading.show({
                container: this.$refs.search_tab
            });

            // if (!localStorage.getItem('authToken')) {
            //     this.$router.push({name: 'Login'})
            // } else {
            axios
                .get("/api/visualization/shop_profile", {
                    params: {
                        showroom: this.showroom
                    }
                })
                .then(res => {
                    if (_.isEmpty(res.data)) {
                        loaderd.hide();
                        Toast.fire({
                            icon: "warning",
                            title:
                                "No Showroom Found, Please Enter Correct Showroom Id."
                        });
                    } else {
                        this.show_search = true;
                        //  this.showroom=res.data.data[0].id
                        this.AddItemShowroom(res.data.data);

                        this.updateCategory({
                            parent: "all",
                            sub: "",
                            list: res.data.data.category,
                            type: "parent"
                        });

                        this.updateMyItem({
                            showroom: res.data.data.profile.user_id,
                            vsd_id:this.vsid
                        });

                        this.$router
                            .push("/visualize/contractor/all")
                            .catch(() => {});
                    }
                })
                .catch(err => {
                    loaderd.hide();
                });
            //   }

            loaderd.hide();
        },

        async filter_contractor() {
            if (this.search_text.length > 2 || this.search_text.length == 0) {
                this.show_search = false;
                let loaderd = "";
                this.$nextTick(function() {
                    loaderd = this.$loading.show({
                        container: this.$refs.search_tab
                    });
                });
                axios
                    .get("/api/visualization/showrooms", {
                        params: {
                            s: this.search_text
                        }
                    })
                    .then(res => {
                        this.showrooms = res.data.data;
                        if (res.data.data.length > 0) {
                            this.show_search = true;
                            this.showroom = res.data.data[0].id;
                            this.showroom_name = res.data.data[0].company_name;
                            this.vsid = res.data.data[0].vsd_id;
                        } else {
                            Toast.fire({
                                icon: "warning",
                                title:
                                    "No Showroom Found, Please Enter Correct Showroom Id."
                            });
                        }
                        loaderd.hide();
                    })
                    .catch(err => {
                        loaderd.hide();
                    });
            }
        }
    },

    mounted() {
        localStorage.removeItem("category");
        localStorage.removeItem("breadcrumb");
        this.updateNewLayout("Yes");
    }
};
</script>
